<template>
  <div id="paypal-button-container">
    <input type="hidden" name="bn" value="ReadyBytes_SP" />
  </div>
</template>
<script>
import {paymentActionClassifier} from '@/mixins/monetization.js';
import { mapGetters } from "vuex";
import {mapFields} from "vuex-map-fields"

export default {
  name: 'PayPalCheckout',
  props: [
    'pricing_id',
    'coupon_code',
    'price',
    'company',
    'event_type',
    'screener_id',
  ],
  data() {
    return {
      clientId: this.DEFINES.PAYPAL_CLIENT_ID,
    };
  },
  mixins: [paymentActionClassifier],
  computed:{
    ...mapGetters("affiliation", {
        affiliation: "get",
    }),
    ...mapFields("consumer", {
        consumer_uuid: "uuid",
    }),
  },
  mounted() {
    this._loadPaypalJs();
  },
  destroyed() {
    this._unloadPaypalJs();
  },
  methods: {
    _loadPaypalJs() {
      let existScript = document.getElementById('me-paypal');
      var _this = this;
      if (!existScript) {
        const jsScript = document.createElement('script');
        jsScript.src =
          'https://www.paypal.com/sdk/js?client-id=' +
          this.DEFINES.PAYPAL_CLIENT_ID +
          '&currency=' +
          this.company.currency;
        jsScript.id = 'me-paypal';
        document.body.appendChild(jsScript);
        jsScript.addEventListener('load', () => {
          _this._loadPaypalBtns();
        });
      } else {
        _this._loadPaypalBtns();
      }
    },

    _unloadPaypalJs() {
      let paypalScript = document.getElementById('me-paypal');
      paypalScript.remove();
    },

    _loadPaypalBtns() {
      var _this = this;
      const elementExists = document.getElementById('paypal-button-container');
      if (elementExists) {
        paypal
          .Buttons({
            fundingSource: paypal.FUNDING.PAYPAL,
            createOrder: function(data, actions) {
              // This function sets up the details of the transaction, including the amount and line item details.
              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      value: _this.price,
                      currency_code: _this.company.currency,
                    },
                  },
                ],
              });
            },
            onApprove: function(data, actions) {
              // on approve capture the payment at serverSide
              return _this.capturePayment(data.orderID);
            },
            onError: function(err) {
              // FIXME: handle specific error such as currency not supported
              _this.$store.dispatch('app/showMessage', {
                message: err,
                color: 'error',
              });
              _this.$emit('resetDialog');
            },
            onCancel: function() {
              _this.$emit('resetDialog');
            },
          })
          .render('#paypal-button-container');
      }
    },

    async capturePayment(orderId) {
      try {
        const payload = {
          orderId: orderId,
          pricing_id: this.pricing_id,
          screener_id: this.screener_id,
          coupon_code: this.coupon_code,
          charge_type: 'paypal',
          affiliation: this.affiliation,
          consumer_uuid : this.consumer_uuid,
        };
        const action = this._moduleWithAction();
        let responce = await this.$store.dispatch(action, payload);
        this.$emit('purchased', responce);
      } catch (error) {
        this.$emit('resetDialog');
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>
